import { useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from 'contexts/AuthContext'
import { useLogoutMutation } from 'api/authApi'
import { getRefreshToken } from 'utils'

const Logout = () => {
  const { logout, isLoggedIn } = useAuth()
  const [callLogout] = useLogoutMutation()

  useEffect(() => {
    const refreshToken = getRefreshToken()
    if (refreshToken) {
      callLogout({ refreshToken })
        .unwrap()
        .catch(() => {
          // Best-effort — server-side revoke is nice but not required;
          // clearing local tokens below is what actually logs the user out.
        })
        .finally(() => logout())
    } else {
      logout()
    }
  }, [callLogout, logout])

  if (!isLoggedIn) return <Navigate to="/login" replace />
  return null
}

export default Logout
